import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import type { Router } from "@remix-run/router";
import Login from "../web/Login";
import Register from "../web/Register";
import Dashboard from "../web/Dashboard";
import {lang} from "../Utils/lang";
import withRole from "./withRole";
import HeaderAndSlider from "../Components/Reusable/HeaderAndSlider";
import Companies from "../web/Companies";
import Users from "../web/Users";
import { localUrlEnum } from "./urlEnum";

type LocalRouterProps = {
  routes: Array<string> | undefined;
};

function LocalRouter(props: LocalRouterProps) {
  const routerPaths = [
    {
      path: "/",
      element: <Register />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: localUrlEnum.companies,
      element: addHeaderAndMenu(<Companies />, lang.companies),
    },
    {
      path: localUrlEnum.dashboard,
      element: addHeaderAndMenu(<Dashboard />, lang.dashboard),
    },
    {
      path: localUrlEnum.users,
      element: addHeaderAndMenu(<Users />, lang.users),
    }
  ];

  const [router, setRouter] = useState<Router>();

  useEffect(() => {
    if (!props.routes) return;

    const newRouterPaths = routerPaths.filter((crtRoute) => {
      return props.routes && props.routes.indexOf(crtRoute.path) >= 0;
    });
    setRouter(createBrowserRouter(newRouterPaths));
  }, [props]);

  function addHeaderAndMenu(component: any, title: string) {
    return <HeaderAndSlider key={title} title={title} component={component} />;
  }

  return router && <RouterProvider router={router} />;
}

export default withRole(LocalRouter);
